"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SearchBar;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _search = _interopRequireDefault(require("@ux/search"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Wrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Wrapper",
  class: "pl-w15nhmk3"
});
const SearchBarWrapper = /*#__PURE__*/(0, _react2.styled)("form")({
  name: "SearchBarWrapper",
  class: "pl-stdfdmk"
});
const SearchInput = /*#__PURE__*/(0, _react2.styled)(_search.default)({
  name: "SearchInput",
  class: "pl-sx3ry5g"
});
const SearchButton = /*#__PURE__*/(0, _react2.styled)(_merchButton.NSMerchButton)({
  name: "SearchButton",
  class: "pl-s1lvl2m3"
});
function SearchBar({
  _name,
  id,
  placeholder,
  buttonText,
  clearAriaLabel,
  value,
  step,
  autocomplete,
  search,
  showTray,
  inputRef,
  handleKeyDown,
  partialTheme = 'site-search-form',
  ...rest
}) {
  const searchFormRef = (0, _react.useRef)();
  const {
    width
  } = (0, _patternLibraryUtils.useWindowSize)();
  (0, _react.useEffect)(() => {
    if (showTray) {
      searchFormRef.current.querySelector('input').focus();
    }
  }, [showTray, searchFormRef]);
  const button = /*#__PURE__*/_react.default.createElement(SearchButton, {
    icon: width > _patternLibraryUtils.size.mobileLg ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null) : /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "search",
      width: 24,
      height: 24
    }),
    text: width > _patternLibraryUtils.size.mobileLg ? buttonText : '',
    "aria-label": buttonText,
    design: "primary",
    onClick: () => search(value),
    _name: `${_name}_input_submit`,
    isPromo: false,
    type: "submit",
    disabled: value.trim().length < 2
  });
  function handleSubmit(e) {
    e.preventDefault();
    search(value);
  }
  function showSearchButton() {
    return step === 'initial' && value.length > 0 || step === 'suggestions';
  }
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    "data-cy": "bar-wrapper"
  }, /*#__PURE__*/_react.default.createElement(SearchBarWrapper, {
    role: "search",
    ref: searchFormRef,
    action: "",
    "data-partial": partialTheme,
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    fill: _intents.default.ux.box.foregroundColor,
    name: "search",
    "data-cy": "icon",
    width: 24,
    height: 24
  }), /*#__PURE__*/_react.default.createElement(SearchInput, (0, _extends2.default)({}, rest, {
    "data-cy": "input",
    "data-searchterm": value,
    "data-partial": partialTheme,
    id: `search-input-${id}`,
    placeholder: placeholder,
    "aria-label": placeholder,
    value: value,
    clearable: step === 'results' || step === 'noResults',
    ariaLabels: {
      clear: clearAriaLabel
    },
    onChange: autocomplete,
    button: showSearchButton() ? button : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null),
    ref: inputRef,
    onKeyDown: handleKeyDown,
    "data-tray": showTray
  }, _patternLibraryUtils.tracking.create(`${_name}_input_bar`, false, false)))));
}
SearchBar.propTypes = {
  _name: _propTypes.default.string,
  id: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  buttonText: _propTypes.default.string,
  clearAriaLabel: _propTypes.default.string,
  value: _propTypes.default.string,
  step: _propTypes.default.string,
  autocomplete: _propTypes.default.func,
  search: _propTypes.default.func,
  showTray: _propTypes.default.bool,
  inputRef: _propTypes.default.object,
  handleKeyDown: _propTypes.default.func,
  partialTheme: _propTypes.default.string,
  ..._search.default.propTypes
};